// /components/Page404.js
import React from "react";
import { Link, useLocation } from "react-router-dom";
import { translations } from "../translations"; // Importer les traductions

const NotFoundPages = () => {
  const location = useLocation();
  const currentLang = location.pathname.split('/')[1] || 'fr'; // Extraire la langue de l'URL (fr par défaut)
  const t = translations[currentLang]; // Sélectionner les traductions appropriées

  return (
    <div className="flex items-center justify-center min-h-screen  text-center p-8">
      <div className="max-w-md w-full bg-light p-8 rounded-lg shadow-lg">
        <h1 className="text-6xl font-bold text-primary mb-4">404</h1>
        <p className="text-xl text-dark mb-6">{t.page404Message || "Oups ! La page que vous cherchez n'existe pas."}</p>
        <Link
          to={`/${currentLang}`}
          className="text-white bg-accent px-6 py-3 rounded-xl font-semibold hover:bg-deepblue transition-colors duration-300"
        >
          {t.goBackHome || "Retourner à l'accueil"}
        </Link>
      </div>
    </div>
  );
};

export default NotFoundPages;
